import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownloadIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 15.7 15.8",
	style: { enableBackground: "new 0 0 15.7 15.8" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.download-icon-st0{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n"
	}), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			className: "download-icon-st0",
			d: "M4.5,6.5l3.3,3.3l3.3-3.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "download-icon-st0",
			d: "M7.8,1v8.7"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "download-icon-st0",
			d: "M14.7,9.8v4.4c0,0.2-0.1,0.3-0.2,0.4s-0.3,0.2-0.4,0.2H1.6c-0.2,0-0.3-0.1-0.4-0.2C1.1,14.5,1,14.3,1,14.2 V9.8"
		})
	] }) }) })]
});
export default SvgDownloadIcon;
